import { render } from "./GenReports.vue?vue&type=template&id=4f2e4921&scoped=true"
import script from "./GenReports.vue?vue&type=script&lang=js"
export * from "./GenReports.vue?vue&type=script&lang=js"

import "./GenReports.vue?vue&type=style&index=0&id=4f2e4921&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e4921"]])

export default __exports__